import { connect } from 'react-redux'
import { actions, jsonApiWrapper } from '@opallabs/wormhole'
import { Sidebar } from '.'

const ConnectedSidebarComponent = (props) => <Sidebar {...props} />

const mapStateToProps = (state, props) => {
  let additionalProps

  if (state.jsonApiEntities && state.jsonApiEntities.slide) {
    const slide = state.jsonApiEntities.slide[props.slideId]

    const { background_asset_reference: backgroundAssetRef = null } =
      jsonApiWrapper({
        data: slide,
        state,
      }) || {}

    additionalProps = {
      backgroundAssetReference: backgroundAssetRef,
    }
  }

  return additionalProps || {}
}

const mapDispatchToProps = (dispatch) => ({
  /**
   * @param {File} file
   */
  uploadAsset: (file, onUploadSuccess) => {
    dispatch(
      actions.handleAssetUploadV2({
        file,
        onUploadSuccess,
      })
    )
  },
  /**
   * @param {number} presentationId
   * @param {number} slideId
   */
  updateSlide: (presentationId, slideId, changes, callback) => {
    dispatch(actions.updateSlide(presentationId, slideId, changes))
      .then(callback)
      .catch(console.error)
  },
})

const ConnectedSidebar = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedSidebarComponent)

export { ConnectedSidebar }
